export enum TemperatureUnitEnum {
    Celsius = 0,
    Fahrenheit = 1
}
